export function getEnvironmentFromHostname() {
  const host = window.location.hostname;
  if (host === 'localhost' || host === '127.0.0.1:3000') return 'local';
  if (host.includes('dev-frontend')) return 'dev';
  if (host.includes('staging-frontend')) return 'staging';
  if (host.includes('portal.hakimo.ai')) return 'prod';
  if (host === '192.168.20.102:8080') return 'gamma';
  if (host === '192.168.20.101:8090') return 'beta';
  // Add more rules as needed
  return 'unknown';
}
